import React from "react";

export const SummaryRow = ({
  icon,
  label,
  value,
  note,
  bold,
  divider = true,
  extraDetails = '',
  className = '',
  itemDescription = ''
}) => (
  <div
    className={`order-summary-row d-flex align-items-start py-2 ${className}`}
    style={{ position: "relative" }}
  >
    {icon && (
      <img className="mr-2 cart-item-icon" src={icon} alt="icon" />
    )}
    <div className="flex-grow-1">
      <div className="mb-0" style={{ fontSize: 16 }}>
        <span className={bold ? "font-weight-bold" : ""}>{label}</span>
        {extraDetails && (
          <span style={{ fontWeight: 400, color: "#666", marginLeft: 4 }}>
            : {extraDetails}
          </span>
        )}
        {itemDescription && (
          <span style={{ fontWeight: 400, color: "#888", marginLeft: 4 }}>
            {itemDescription}
          </span>
        )}
      </div>
      {note && (
        <div style={{ fontSize: 12, color: "#888" }}>{note}</div>
      )}
    </div>
    {value !== undefined && (
      <div className="ml-3">{value}</div>
    )}
    {divider && (
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: 1,
          background: "#e6e6e6",
        }}
      />
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/SummaryRow.js